import toastService from "Root/profile/toastService";
import { apiGetOrdersHistory } from "Root/api/apiProfile";
export const fetchOrdersHistoryThunk = (setOrders, setIsComplete, setNextIndex) => async () => {
    try {
        const response = await apiGetOrdersHistory(0);
        const { data } = response;
        setOrders(data);
        setIsComplete(response.endOfData);
        setNextIndex(response.nextIndex);
    }
    catch (e) {
        toastService.errorMessage(e);
    }
};
export const fetchMoreOrdersThunk = (setOrders, setIsComplete, setNextIndex, setFetchingMore, nextIndexReduxRef, ordersReduxRef) => async () => {
    try {
        const response = await apiGetOrdersHistory(nextIndexReduxRef);
        const { data } = response;
        const old_orders = ordersReduxRef;
        const all_orders = old_orders.concat(data);
        setOrders(all_orders);
        setIsComplete(response.endOfData);
        setNextIndex(response.nextIndex);
        setFetchingMore(false);
    }
    catch (e) {
        toastService.errorMessage(e);
    }
};
